import { ISelectedBettingOption } from '@bg-shared/interfaces/IBettingOption';

export const getRunId = (odd: ISelectedBettingOption): number =>
    Number(odd.isNextRun ? odd.draw.nextRunId : odd.draw.runId);
